// WARNING: DO NOT EDIT. This file is automatically generated.

const awsConfig = {
    "region": "eu-west-1",
    "stage": "status-test",
    "accountName": "development",
    "api_url": "https://tva1uamkr5.execute-api.eu-west-1.amazonaws.com/status-test/graphql",
    "notifications_api_url": "https://tva1uamkr5.execute-api.eu-west-1.amazonaws.com/status-test/notifications",
    "run_daily_test_url": "https://sadroeq8df.execute-api.eu-west-1.amazonaws.com/test/run-daily-test",
    "sport_highlights_url": "https://r365vowf6ngmxnnrthbo3spcxe.appsync-api.eu-west-1.amazonaws.com/graphql",
    "appconfig_url": "https://tva1uamkr5.execute-api.eu-west-1.amazonaws.com/status-test/getConfig",
    "direct_appconfig_url": "https://r365vowf6ngmxnnrthbo3spcxe.appsync-api.eu-west-1.amazonaws.com/graphql",
		"endpoint_url" : "https://tva1uamkr5.execute-api.eu-west-1.amazonaws.com/status-test",
    "mgmt_ui_appconfig_dropdown_profile": "mgmt-ui-dropdown-options",
    "mgmt_ui_appconfig_configs_profile": "mgmt-ui-configs",
    "daily-test-game-configs": "daily-testing-configs",
    "leagues": "leagues",
    "aws_project_region": "eu-west-1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_tEOwEhzuj",
    "aws_user_pools_web_client_id": "5hdmfqflrap478ofmeiv73im3s",
    "oauth": {
        "domain": "spex-mgmt-ui-hosting-status-test.auth.eu-west-1.amazoncognito.com",
        "scope": [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://mgmt.status-test.spex-dev.aidisco.sky.com",
        "redirectSignOut": "https://mgmt.status-test.spex-dev.aidisco.sky.com",
        "responseType": "code"
    },
    "bitmovinLicenseKey": "2c2acb4c-6bb3-4087-98d2-0d5ecc0a6258",
    "defaultChannelName": "ExternalSLE",
    "licenseAcquisitionEndpointUrl": "",
    "arcusLicenseAcquisitionEndpointUrl": ""
};

export default awsConfig;

